<div class="container">
    <div class="form-container">
        <div>
            <label class="label">{{'doTheMemberDetailsExistInLastQuarter' | translate}} </label>
            <drop-down [options]="existingMemberOptions"
                [control]="saveDetailFromLastQuarterCtrl"
            >
            </drop-down>
        </div>
        <div *ngIf="saveDetailFromLastQuarterCtrl.value === 'Yes'">
            <label class="label">{{'memberName' | translate}}</label>
            <div>
                <input matInput class="input-autocomplete" type="text" [matAutocomplete]="memberAuto"
                    [formControl]="memberCtrl" placeholder="Type to search member">
                <mat-autocomplete #memberAuto="matAutocomplete"
                    [autoActiveFirstOption]="false" [displayWith]="displayWithMember">
                    <mat-option *ngFor="let member of membersData" [value]="member" (click)="selected()">
                        {{member.memberName}}&nbsp;({{member.memberId}})
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="showMemberNameError">{{'pleaseSelectAMember' | translate}}</mat-error>
                <mat-error *ngIf="showAlreadyRegisteredError">{{'memberAlreadyRegistered' | translate}}</mat-error>
            </div>
        </div>
    </div>
    <div class="btn-grp">
        <button class="button" (click)="close(true)">{{'close' | translate}}</button>
        <button class="button" (click)="close()">{{'ok' | translate}}</button>
    </div>
</div>